<!-- eslint-disable vue/multi-word-component-names -->
<script setup>


</script>

<template>
  <main class="w-full h-auto  my-5">
    <section class="container mx-auto h-[435px]  flex  justify-center items-center">
      <section class="w-9/12 h-full flex flex-col justify-start items-start">
        <span class="w-full text-center font-bold text-xl">WHERE YOU CAN FIND US</span>

        <div class="w-full  h-auto my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">Address:</span>
          </div>

          <p>
            Raya Building, Rahmatabad, Ghasrodasht St., Opposite Alley 34, Shiraz, Fars Province, Iran   
          </p>
        </div>


        <section class="w-full h-auto grid grid-cols-2 gap-5">
          <div class="w-full h-[50px] my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">Tel.:</span>
          </div>
          <a href="tel:+987136278933">+98 71 36278933</a>
          </div>

        <div class="w-full h-[50px] my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">Tel.:</span>
          </div>
          <a href="tel:+987136278932">+98 71 36278932</a>
        </div>

      

        <div class="w-full h-[50px] my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">Whatsapp.:</span>
          </div>
          <a href="https://wa.me/989338486108">+98 9338486108</a>
        </div>
        
        <div class="w-full h-[50px] my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">Fax.:</span>
          </div>
          <span>+98 71 36278933</span>
        </div>

        <div class="w-full h-[50px] my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">Zip Code.:</span>
          </div>
          <span>7183793815</span>
        </div>

        <div class="w-full h-[50px] my-2 flex flex-col justify-start items-start">
          <div class="w-auto h-auto flex justify-start items-center">
            <div class="w-2 h-2 bg-sky-600 rounded-full"></div>
            <span class="text-sky-500 mx-2 font-bold text-lg">E-mail.:</span>
          </div>
          <a href="mailto:info@rayagroupco.com">info@rayagroupco.com</a>
        </div>
        </section>



      </section>
    </section>
  </main>
</template>

<style scoped></style>
